module.exports = __webpack_public_path__ + "media/images/lb/462-621d797399598b06b5077edb59e9775d.svg";